const sharedHeaders = [
  {
    "key": "api-key",
    "required": true,
    "type": "string",
    "description": "Your API key, for more information see <a href='/authentication'>Authentication</a>",
    "example": "AS_wWa7hTkJNQEzmzv4ZpGh"
  },
  {
    "key": "language",
    "required": false,
    "type": "string",
    "description": "Language of the response, accepted values are <code>fr</code>, <code>en</code>, <code>es</code> or <code>it</code>",
    "example": "en"
  }
]

export { sharedHeaders }
